import { render, staticRenderFns } from "./RestMaterials.vue?vue&type=template&id=c12a3712&scoped=true"
import script from "./RestMaterials.vue?vue&type=script&lang=js"
export * from "./RestMaterials.vue?vue&type=script&lang=js"
import style0 from "./RestMaterials.vue?vue&type=style&index=0&id=c12a3712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12a3712",
  null
  
)

export default component.exports